import { OfferRedirectLink, EligibleAffiliate } from '../../../types';
import { PersonalLoanRedirectScreenState } from './Types';

export const OfferRedirectLinkActions = {
  DATA_LOADING: 'loadingOfferRedirectLinksData',
  DATA_FAILED: 'loadingFailedOfferRedirectLinksData',
  DATA_LOADED: 'loadedOfferRedirectLinksData',

  CREATE_ENTRY: 'createOfferRedirectLinkEntry',
  EDIT_ENTRY: 'editOfferRedirectLinkEntry',
  CANCEL_ENTRY: 'cancelOfferRedirectLinkEntry',

  SEARCH_KEYWORD_CHANGED: 'searchOfferRedirectLinkChanged',

  SAVED_ENTRY: 'savedAllOfferRedirectLink',
  FAILED_SAVING_ENTRY: 'failedSavingOfferRedirectLink',
  HISTORY_LOADED: 'loadedOfferRedirectHistory',
  HISTORY_FILTER_CHANGED: 'offerRedirectHistoryFilterChanged',
};

export const EligibleAffiliateActions = {
  DATA_LOADING: 'loadingEligibleAffiliatesData',
  DATA_FAILED: 'loadingFailedEligibleAffiliatesData',
  DATA_LOADED: 'loadedEligibleAffiliatesData',

  CREATE_ENTRY: 'newEligibleAffiliateEntry',
  EDIT_ENTRY: 'editEligibleAffiliateEntry',
  CANCEL_ENTRY: 'cancelEligibleAffiliateEntry',

  SEARCH_KEYWORD_CHANGED: 'searchEligibleAffiliateChanged',
  SAVED_ENTRY: 'savedEligibleAffiliate',
  FAILED_SAVING_ENTRY: 'failedSavingEligibleAffiliate',
  HISTORY_LOADED: 'loadedEligibleAffiliateHistory',
  HISTORY_FILTER_CHANGED: 'eligibleAffiliateHistoryFilterChanged',
};

export const PersonalLoanRedirectState = {
  NORMAL: '',
  LOADING: 'loading',
  SAVING: 'saving',
  HISTORY: 'history',
};

export const BLANK_OfferRedirectLink: OfferRedirectLink = {
  OfferRedirectLinkId: 0,
  OfferId: 0,
  CreditRatingBucket: '',
  RedirectUrl: '',
  IsActive: false,
  CreatedDate: '',
  ModifiedDate: '',
};

export const BLANK_OfferRedirectLinkWorkspaceData = {
  data: { ...BLANK_OfferRedirectLink },
  filtered: false,
};

export const BLANK_EligibleAffiliate: EligibleAffiliate = {
  EligibleAffiliateId: 0,
  AffiliateId: 0,
  IsActive: false,
  CreatedDate: '',
  ModifiedDate: '',
};

export const BLANK_EligibleAffiliateWorkspaceData = {
  data: { ...BLANK_EligibleAffiliate },
  filtered: false,
};

export const isValidOfferRedirectLink = (orl: OfferRedirectLink): boolean => {
  const isDigitRegex = /\d+/;
  const isAbbrevRegex = /[A-Z]+/;
  const isLinkRegex = /^((?:http(s)?:)?\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

  return (
    orl !== null &&
    isDigitRegex.test(orl.OfferId.toString()) &&
    orl.OfferId * 1 !== 0 &&
    isAbbrevRegex.test(orl.CreditRatingBucket) &&
    isLinkRegex.test(orl.RedirectUrl)
  );
};

export const isValidEligibleAffiliate = (ea: EligibleAffiliate): boolean => {
  const isDigitRegex = /\d+/;

  return ea !== null && isDigitRegex.test(ea.AffiliateId.toString());
};

export const DEFAULT_STATE: PersonalLoanRedirectScreenState = {
  loadStatus: 0,
  offerRedirectLinks: {
    list: [],
    search: '',
    form: {
      data: { ...BLANK_OfferRedirectLink },
      enabled: false,
      errors: [],
    },
    keyword: '',
    state: '',
    history: {},
    historyFilter: {
      keyword: '',
      user_id: '',
      action: '',
    },
    historyFilterOptions: {
      users: [],
      actions: [],
    },
  },
  affiliates: {
    list: [],
    search: '',
    form: {
      data: { ...BLANK_EligibleAffiliate },
      enabled: false,
      errors: [],
    },
    keyword: '',
    state: '',
    history: {},
    historyFilter: {
      keyword: '',
      user_id: '',
      action: '',
    },
    historyFilterOptions: {
      users: [],
      actions: [],
    },
  },
};
